module.exports = __webpack_public_path__ + "static/media/27.e5d8396a.jpeg";